<ifa-share-offer *ngIf="!customerView" class="table-wrapper" [offer]="offer"></ifa-share-offer>

<ifc-offer-draw-slider [offerCalculator]="offerCalculator" [productCode]="'Law'"></ifc-offer-draw-slider>

<ifc-offer-calculator-details-table [offerCalculator]="offerCalculator"
                                    [showCommission]="!customerView && !isRenewal"
                                    [showTerm]="false"
                                    (showDisclosures)="onShowDisclosures($event)">
</ifc-offer-calculator-details-table>

<ifa-calculator-closing-requirements [checkoutRequirements]="checkoutRequirements"></ifa-calculator-closing-requirements>

<ifa-link-your-bank [applicationUuid]="uuid" [bankLinkStatus]="application?.bankLinkStatus" ></ifa-link-your-bank>

<ifc-offer-calculator-payment-schedule [offer]="offer" [sampleDraw]="offerCalculator.sampleDraw" [isPublicView]="true"></ifc-offer-calculator-payment-schedule>
